import axios from 'axios';
import qs from 'qs';
import { ERROR_CODE, ErrorModalTypes } from '../constants/error.constant';
import { AxiosConstant } from '../constants/axios.constant';
import { getEndpointBase } from './api.service';
import { setDispatchModal, setKCUser, setServerError } from '../redux/App/App.slice';
import { ThunkDispatch } from '@reduxjs/toolkit';
import { storageConstant } from '../constants/storage.constant';
import { ssoRefreshThunk } from '../redux/App/App.thunk';
import locationStorageAdapter from './adapters/locationStorage.adapter';
import { keycloak } from '../keycloak';

const { ACCESS_TOKEN, REFRESH_TOKEN } = storageConstant;

const axiosService = axios;
let isNetworkError = false;
let isAlreadyFetchingAccessToken = false;
let subscribers: any[] = [];

const deleteToken = (name: string) => locationStorageAdapter.delete(name);

const onCallSubscribers = (value?: string) => {
  subscribers = subscribers.filter(callback => callback(value));
};

const addSubscriber = (callback: any) => {
  subscribers.push(callback);
};

const checkNetworkConnect = () => {
  axiosService
    .get(getEndpointBase('ping'))
    .then((data: any) => {
      isNetworkError = false;
      // @ts-ignore
      const dispatch = axiosService.dispatch as ThunkDispatch<any, any, any>;
      dispatch(setDispatchModal(undefined));
      onCallSubscribers();
    })
    .catch(() => {
      setTimeout(() => checkNetworkConnect(), AxiosConstant.RETRY_TIMEOUT);
    });
};

const authConfig = {
  deleteTokens: () =>
  {
    deleteToken(ACCESS_TOKEN);
    deleteToken(REFRESH_TOKEN);
  },
  getAccessToken: () => Promise.resolve('')
};
export const config = authConfig;

axiosService.interceptors.request.use(
  async config => {
    const token = keycloak.token || await authConfig.getAccessToken();
    if (token && token !== '') {
      config.headers = {
        Authorization: `Bearer ${token}`,
      };
    }
    config.paramsSerializer = (params: any) => {
      return qs.stringify(params, { arrayFormat: 'comma', encode: false });
    };
    return config;
  },
  error => {
    Promise.reject(error);
  },
);

axiosService.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    const { config } = error;
    const originalRequest = config;
    // @ts-ignore
    const dispatch = axiosService.dispatch as ThunkDispatch<any, any, any>;
    if (error?.response?.status === 500 && error.code === ERROR_CODE.ERR_BAD_RESPONSE) {
      dispatch(setServerError(error));
    }

    if (
      error.code === ERROR_CODE.NETWORK
    ) {
      if (!isNetworkError) {
        isNetworkError = true;
        // @ts-ignore
        const dispatch = axiosService.dispatch as ThunkDispatch<any, any, any>;
        dispatch(
          setDispatchModal({
            type: ErrorModalTypes.NETWORK_ERROR,
            data: {
              isBlocked: true,
            },
          }),
        );
        setTimeout(() => {
          checkNetworkConnect();
        }, AxiosConstant.RETRY_TIMEOUT);
      }

      return new Promise(resolve => {
        addSubscriber(() => resolve(axios(originalRequest)));
      });
    }

    const { response } = error;

    if (response && response.status) {
      const { status } = response;

      if (status === ERROR_CODE.LOCKED) {
        if (!isAlreadyFetchingAccessToken) {
          isAlreadyFetchingAccessToken = true;
          // @ts-ignore
          const dispatch = axiosService.dispatch as ThunkDispatch<
            any,
            any,
            any
          >;
          dispatch(setKCUser(undefined));
          ssoRefreshThunk();
        }

        return new Promise(resolve => {
          addSubscriber((token: string) => {
            originalRequest.headers.Authorization = `Bearer ${token}`;
            resolve(axios(originalRequest));
          });
        });
      }

      if (status === ERROR_CODE.UNAUTHORIZED) {
        authConfig.deleteTokens();
        window.location.reload();
        return;
      }
    }

    if (axios.isCancel(error)) return Promise.reject(error);

    return Promise.reject(error);
  },
);

export default axiosService;
